import { cn } from '@/utils/cn'

const BADGE_STYLES: Record<string, string> = {
  crypto: 'bg-tv-purple/20 text-purple-300',
  nse_index: 'bg-tv-blue/20 text-blue-300',
  nse_futures: 'bg-yellow-500/20 text-yellow-300',
  nse_stock: 'bg-tv-green/20 text-green-300',
  us_stock: 'bg-tv-orange/20 text-orange-300',
}

const BADGE_LABELS: Record<string, string> = {
  crypto: 'Crypto',
  nse_index: 'Index',
  nse_futures: 'Futures',
  nse_stock: 'NSE',
  us_stock: 'US',
}

interface AssetBadgeProps {
  assetClass: string
  className?: string
}

export function AssetBadge({ assetClass, className }: AssetBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-1.5 py-0.5 text-2xs font-medium uppercase tracking-wide',
        BADGE_STYLES[assetClass] ?? 'bg-tv-bg-tertiary text-tv-text-secondary',
        className
      )}
    >
      {BADGE_LABELS[assetClass] ?? assetClass}
    </span>
  )
}
